import { render, staticRenderFns } from "./Triangle.svg.vue?vue&type=template&id=7c1d9908"
import script from "./Triangle.svg.vue?vue&type=script&lang=ts"
export * from "./Triangle.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1d9908')) {
      api.createRecord('7c1d9908', component.options)
    } else {
      api.reload('7c1d9908', component.options)
    }
    module.hot.accept("./Triangle.svg.vue?vue&type=template&id=7c1d9908", function () {
      api.rerender('7c1d9908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/Triangle.svg.vue"
export default component.exports